module.exports = __webpack_public_path__ + "static/media/UtilityPic.f002edf4.png";